/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum Platform {
  Unknown = 1,
  Windows = 2,
  Mac = 4,
  iOS = 8,
  iPadOS = 16,
  Linux = 32,
  Android = 64,
  ChromeOS = 128,
  Others = 256
}
